import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setProjectList } from 'Workspace/Projects/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';
import workspaceService from 'services/WorkspaceService';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection) {
  const workspaceProjectList = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_PROJECT_LIST,
    workspaceId: workspaceService.getSelectedWorkspaceId(),
  });
  if (workspaceProjectList.type === constants.RTM_WORKSPACE_PROJECT_LIST_OK) {
    const projects = workspaceProjectList.response.projects;
    yield put(setProjectList(projects));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspaceProjectList} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_PROJECT_LIST, catchErrors, sendRequest, connection);
}
